import { useState } from "react";
import { useTranslation } from "react-i18next";
import tw from "twin.macro";

import ManualModuleSearch from "@/routes/scan-module/manual-module-search";
import QuickModuleAccess from "@/routes/scan-module/quick-module-access";

import { SheetsEnum } from "./enums/sheets.enum";
import { SheetsType } from "./types/sheets.type";

type ActiveTab = "qr" | "search";

const TabBar = ({
  activeTab,
  onChange,
}: {
  activeTab: ActiveTab;
  onChange: (tab: ActiveTab) => void;
}) => {
  const { t } = useTranslation();

  const TABS: { key: ActiveTab; emoji: string; label: string }[] = [
    { key: "qr", emoji: "📷", label: t("quickModuleAccess.tabQr") },
    { key: "search", emoji: "🔍", label: t("quickModuleAccess.tabSearch") },
  ];

  return (
    <div tw="flex border-b border-gray-100 mx-4 mb-4">
      {TABS.map(({ key, emoji, label }) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          css={[
            tw`flex-1 flex items-center justify-center gap-1.5 py-2.5 text-sm font-medium border-b-2 transition`,
            activeTab === key
              ? tw`text-primary-800 border-primary-800`
              : tw`text-gray-500 border-transparent`,
          ]}
        >
          <span>{emoji}</span>
          {label}
        </button>
      ))}
    </div>
  );
};

type ScanModuleSheetBodyProps = {
  pushSheet: (view: SheetsType) => void;
};

const ScanModuleSheetBody = ({ pushSheet }: ScanModuleSheetBodyProps) => {
  const [activeTab, setActiveTab] = useState<ActiveTab>("qr");

  const handleModuleAccess = (areaId: string, moduleAddress: string) =>
    pushSheet({
      id: SheetsEnum.MODULE_ACCESS,
      canGoBack: true,
      moduleAddress,
      areaId,
    });

  return (
    <div>
      <TabBar activeTab={activeTab} onChange={setActiveTab} />
      {activeTab === "qr" ? (
        <QuickModuleAccess onScanned={handleModuleAccess} />
      ) : (
        <ManualModuleSearch onSelected={handleModuleAccess} />
      )}
    </div>
  );
};

export default ScanModuleSheetBody;
